export default {"src":"/_next/static/media/borrower.af879268.svg","height":79,"width":79,"blurWidth":0,"blurHeight":0};